export const getInitials = (fullName: string) => fullName
  .split(' ')
  .reduce((str, val) => str + val[0], '')
  .toLocaleUpperCase();

export const getFirstName = (fullName: string): string => fullName.split(' ')[0];

export const colours = ['#ff9405', '#20a0cd', '#7834d4'];
